module.exports = __webpack_public_path__ + "img/boy_bow.8edb1242.svg";